import { render, staticRenderFns } from "./NoAccess.vue?vue&type=template&id=67cd4d74&scoped=true"
var script = {}
import style0 from "./NoAccess.vue?vue&type=style&index=0&id=67cd4d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cd4d74",
  null
  
)

export default component.exports